import { ReactComponent as AnimationIcon } from './animation.svg'
import { ReactComponent as CopyIcon } from './copy.svg'
import { ReactComponent as CrossIcon } from './cross-icon.svg'
import { ReactComponent as HistoryIcon } from './history-icon.svg'
import { ReactComponent as MinusIcon } from './minus-icon.svg'
import { ReactComponent as MusicIcon } from './music.svg'
import { ReactComponent as PlusIcon } from './plus-icon.svg'
import { ReactComponent as RefreshIcon } from './refresh-icon.svg'
import { ReactComponent as RightArrowIcon } from './right-arrow.svg'
import { ReactComponent as DownArrowIcon } from './down-arrow.svg'
import { ReactComponent as SoundIcon } from './sound.svg'
import { ReactComponent as TogglerIcon } from './toggler-icon.svg'
import { ReactComponent as UserIcon } from './user.svg'
import { ReactComponent as CryptoCurrencyIcon } from './Cryptocurrency.svg'
import { ReactComponent as InfinityIcon } from './ph_infinity.svg'
import { ReactComponent as DoubleIcon } from './double-icon.svg'
import { ReactComponent as StandIcon } from './stand-icon.svg'
import { ReactComponent as SplitIcon } from './split-icon.svg'
import { ReactComponent as HitIcon } from './hit-icon.svg'
import { ReactComponent as CrownIcon } from './mdi_crown.svg'
import { ReactComponent as InfoIcon } from './info.svg'
import { ReactComponent as HotkeysIcon } from './hotkeys.svg'
import { ReactComponent as HMenuIcon } from './h-menu.svg'
import { ReactComponent as BarChartIcon } from './bar-chart-fill.svg'
import { ReactComponent as SettingProfile } from './settingProfile.svg'
import { ReactComponent as InstandBetIcon } from './instand-bet.svg'
import { ReactComponent as MaxBetIcon } from './max-bet.svg'
import { ReactComponent as XCloseIcon } from './icon-x-close.svg'
import { ReactComponent as XCrossIcon } from './XCircle.svg'
import { ReactComponent as UndoIcon } from './arrow-u-up-left.svg'
import { ReactComponent as WarningIcon } from './icon-warning.svg'
import { ReactComponent as DiamondIcon } from './diamond-icon.svg'
import { ReactComponent as InfinityBoldIcon } from './infinity_bold.svg'
import { ReactComponent as UpDownArrowIcon } from './up-down-arrow.svg'
import { ReactComponent as KeyboardIcon } from './keyboard.svg'
import { ReactComponent as RocketIcon } from './rocket.svg'
import { ReactComponent as DiceStandIcon } from './stats.svg'
import { ReactComponent as VolumeMuteIcon } from './volume-mute.svg'
import { ReactComponent as VolumeUnMuteIcon } from './volume-unmute.svg'
import { ReactComponent as StateRefreshIcon } from './icon-refresh.svg'
import { ReactComponent as ChartIcon } from './chart.svg'
import { ReactComponent as HiloUpIcon } from './hilo-up-arrow.svg'
import { ReactComponent as HiloDownIcon } from './hilo-down-arrow.svg'
import { ReactComponent as HiloSameIcon } from './hilo-same-icons.svg'
import { ReactComponent as HiloSkipIcon } from './hilo-skip-arrow.svg'
import { ReactComponent as WagerIcon } from '../icons/wager-icon.svg'
import { ReactComponent as CurrencyIcon } from '../icons/currency-icon.svg'
import { ReactComponent as HiloUp } from '../icons/hilo-up.svg'
import { ReactComponent as HiloDown } from '../icons/hilo-down.svg'
import { ReactComponent as CardUp } from '../icons/card-up-arrow.svg'
import { ReactComponent as CardDown } from '../icons/card-down-arrow.svg'
import { ReactComponent as StarMineIcon } from '../icons/star-mine.svg'
import { ReactComponent as CloseConfigIcon } from '../icons/close-config-mine.svg'
import { ReactComponent as RollbackDiceIcon } from '../icons/rollback-dice.svg'
import { ReactComponent as CloseDiceIcon } from '../icons/close-dice.svg'
import { ReactComponent as MinusCircleIcon } from '../icons/minus-circle.svg'
import { ReactComponent as PlusCircleIcon } from '../icons/plus-circle.svg'
import { ReactComponent as CloseWhiteIcon } from './closeWhite.svg'
import { ReactComponent as UpArrowIcon } from './up-arrow.svg'
import { ReactComponent as CopyFillIcon } from './Copy-fill.svg'
export { ReactComponent as MessagesIcon } from './messages-icon.svg'
export { ReactComponent as StatsIcon } from './stats-icon.svg'
export { ReactComponent as PlayIcon } from './play-icon.svg'
export { ReactComponent as ChatSettingIcon } from './chat-setting.svg'
export { ReactComponent as SendIcon } from './carbon-send.svg'
export { ReactComponent as TurnTopArrowIcon } from './turn-top-arrow.svg'
export { ReactComponent as CarbonTimeIcon } from './carbon-time.svg'

// icons export
export {
  HiloUp,
  HiloDown,
  CardUp,
  CardDown,
  AnimationIcon,
  CopyIcon,
  CrossIcon,
  HistoryIcon,
  MinusIcon,
  MusicIcon,
  MinusCircleIcon,
  PlusCircleIcon,
  PlusIcon,
  RefreshIcon,
  RightArrowIcon,
  SoundIcon,
  TogglerIcon,
  UserIcon,
  CryptoCurrencyIcon,
  InfinityIcon,
  DownArrowIcon,
  DoubleIcon,
  StandIcon,
  SplitIcon,
  HitIcon,
  CrownIcon,
  InfoIcon,
  HotkeysIcon,
  BarChartIcon,
  SettingProfile,
  InstandBetIcon,
  MaxBetIcon,
  DiamondIcon,
  XCloseIcon,
  WarningIcon,
  InfinityBoldIcon,
  UpDownArrowIcon,
  KeyboardIcon,
  RocketIcon,
  DiceStandIcon,
  VolumeMuteIcon,
  VolumeUnMuteIcon,
  StateRefreshIcon,
  ChartIcon,
  HiloSkipIcon,
  HiloSameIcon,
  HiloUpIcon,
  HiloDownIcon,
  HMenuIcon,
  WagerIcon,
  CurrencyIcon,
  StarMineIcon,
  CloseConfigIcon,
  XCrossIcon,
  UndoIcon,
  RollbackDiceIcon,
  CloseDiceIcon,
  CloseWhiteIcon,
  UpArrowIcon,
  CopyFillIcon
}
